module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-translation-add"
  }, [_c('div', {
    staticClass: "row column card pt-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("group"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.group),
      expression: "body.group"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('option', {
      domProps: {
        "value": group
      }
    }, [_vm._v(_vm._s(group))])
  }), 0)])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("key"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.key),
      expression: "body.key"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "key", $event.target.value)
      }
    }
  })])])]), (!_vm.langs.length) ? _c('loading-spinner') : _vm._e(), _vm._m(0), _vm._l((_vm.langs), function(lang) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column small-2 large-1 medium-1"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "readonly": "readOnly"
      },
      domProps: {
        "value": lang
      }
    })]), _c('div', {
      staticClass: "column"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.body.value[lang]),
        expression: "body.value[lang]"
      }],
      attrs: {
        "name": lang,
        "rows": "8"
      },
      domProps: {
        "value": (_vm.body.value[lang])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.body.value, lang, $event.target.value)
        }
      }
    })])])
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.firstSaving ? 'Save Translation' : 'Add Another Translation'))])], 1)])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("lang")])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("value")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-592c8b7d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/TranslationAdd.vue
// module id = 2305
// module chunks = 1